/**
 * CLC TA API
 *
 * Contact: 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const UserType = {
    Staff: 'Staff',
    Casual: 'Casual'
} as const;
export type UserType = typeof UserType[keyof typeof UserType];

